export const SAVE_SIDEBAR = 'SETTINGS/SAVE_SIDEBAR';
export const SAVE_THEME = 'SETTINGS/SAVE_THEME';
export const SAVE_BLUR = 'SETTINGS/SAVE_BLUR';
